import React from 'react'
import { withNamespaces } from "react-i18next"
import { MapPin, Grid, Mail, CreditCard, Check } from "lucide-react";
import { connect } from 'react-redux'

class StepBarRental extends React.Component {

  getGradientStyle() {
    const { qrData } = this.props;
    if (qrData?.headerConfig?.primaryColor && qrData?.headerConfig?.secondaryColor) {
      return `linear-gradient(90deg, ${qrData.headerConfig.primaryColor}, ${qrData.headerConfig.secondaryColor})`;
    }
    return 'linear-gradient(45deg, #01315f, #067ddb)';
  }

  getPrimaryTextColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.textPrimary || '#01315f';
  }

  renderStep(stepNumber, currentStep, label, Icon) {
    const isActive = currentStep === stepNumber;
    const isOld = currentStep > stepNumber;

    return (
      <div className="rental-stepparent">
        <div className={
          isOld ? "rental-stepOld" : (isActive ? "rental-stepActive" : "rental-step")
        }>
          {isOld ? <Check size={18}/> : <Icon size={18}/>}
        </div>
        <div className={
          isOld ? "rental-steplabelOld" : (isActive ? "rental-steplabelActive" : "rental-steplabel")
        }>
          {label}
        </div>
      </div>
    );
  }

  render() {
    const step = this.props.step;
    const { t } = this.props;
    const gradientStyle = this.getGradientStyle();

    return (
      <>
        <style>{`
          @keyframes customColorLoopRental {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .rental-stepActive {
            background: ${gradientStyle} !important;
            background-size: 200% 200% !important;
            animation: customColorLoopRental 3s ease infinite !important;
          }
          .rental-stepOld {
            background: ${gradientStyle} !important;
          }
          .rental-steplineOld {
            background: ${gradientStyle} !important;
          }
        `}</style>
        <div className="rental-stepbar">

        {this.renderStep(1, step, t('Zona'), MapPin)}
        <div className={`${step > 1 ? "rental-steplineOld" : "rental-stepline"}`}></div>

        {this.renderStep(2, step, t('Taquilla'), Grid)}
        <div className={`${step > 2 ? "rental-steplineOld" : "rental-stepline"}`}></div>

        {this.renderStep(3, step, t('Email'), Mail)}
        <div className={`${step > 3 ? "rental-steplineOld" : "rental-stepline"}`}></div>

        {this.renderStep(4, step, t('Pago'), CreditCard)}

      </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  qrData: state.qrs.qr
})

export default withNamespaces()(connect(mapStateToProps)(StepBarRental))
